// Use isOneOf(['foo', 'bar', 'baz'], possiblyFoo)
// instead of possiblyFoo === 'foo' || possiblyFoo === 'bar' || possiblyFoo === 'baz'
export const isOneOf = <T>(options: T[], actualValue: T) => options.includes(actualValue);
